import React, { Fragment, useRef } from 'react';

import './list.scss';
import { classSet } from '@umu/umu-dom';
import {
    IListItem,
    EPlatformTravelType as TravelType,
    EPlatformSectionType as SectionType,
    EnterpriseRoleType,
} from '@umu/umu-types';
import { If, PreImg } from 'common/src/components';
import { formatDepartmentName, onDisablePermissionSwitch } from '../../utils';
import { UserAvatar } from '../../../user';
import { lang } from '@umu/ukit-lang';
import { FilterDialog } from '../../../departmentSelectWithExcludeUser/components/filterDialog/filterDialog';

import deleteIcon from '../../images/icon-delete.png';
import topIcon from '../../images/icon-top.png';
import fileIcon from '../../images/icon-file.png';
import rightIcon from '../../images/icon-right.png';
import departmentMemberIcon from '../../images/icon-department-member.png';
import { Tooltip } from '@umu/umu-design';
const iconUnKnownCheck = require('../../images/icon-unknown-check.png');
const iconUnCheck = require('../../images/icon-un-check.png');
const iconCheck = require('../../images/icon-check.png');
interface IProps {
    itemData: IListItem;
    travelType: TravelType;
    sectionType: SectionType;
    index: number;
    selectedNum: number;
    isSearchMode: boolean;
    enterpriseName: string;
    isShowMember?: boolean;
    checkableRoot?: boolean;
    limit?: number;
    hasAllPermissionRoles: EnterpriseRoleType[];
    onSelectedChange: (params: IListItem, isChecked: boolean) => void;
    onNextLevel: (params: IListItem) => void;
    onClickRemove: (params: IListItem) => void;
    onToggleName: (params: IListItem) => void;
    onFilter?: (params: IListItem) => void;
}
export enum CHECKBOX_CHECK_TYPE {
    UN_CHECK,
    IS_CHECK,
    UNKNOWN_CHECK,
}
type ICheckboxMap = {
    [propName in CHECKBOX_CHECK_TYPE]: string;
};
interface ICheckboxProps {
    isChecked: CHECKBOX_CHECK_TYPE;
    disabledCheck?: boolean;
    onChange: (isCheck: boolean) => void;
}

const checkboxMap: ICheckboxMap = {
    [CHECKBOX_CHECK_TYPE.UN_CHECK]: iconUnCheck,
    [CHECKBOX_CHECK_TYPE.IS_CHECK]: iconCheck,
    [CHECKBOX_CHECK_TYPE.UNKNOWN_CHECK]: iconUnKnownCheck,
};

/**
 * 临时方案展示勾选框
 */
export const Checkbox = (props: ICheckboxProps) => {
    const { isChecked, disabledCheck = false, onChange } = props;
    const onClick = () => {
        if (!disabledCheck) {
            onChange(!isChecked);
        }
    };
    return (
        <PreImg>
            <img
                onClick={onClick}
                className={classSet({
                    'icon-img-check': true,
                    'icon-img-check-unknown': isChecked === CHECKBOX_CHECK_TYPE.UNKNOWN_CHECK,
                    'icon-disabled-check': disabledCheck,
                })}
                src={checkboxMap[isChecked]}
            />
        </PreImg>
    );
};
export const ListItem = (props: IProps) => {
    const listChildren: any[] = [];
    const listItemData = props.itemData;
    const { selectedNum } = props;
    const listUlRef = useRef<HTMLUListElement>(null);
    const ListItemDepartmentLeft = (params: IListItem, key: React.Key) => {
        const isSelected = params.isSelected;
        const fullName: string = formatDepartmentName(
            false,
            props.enterpriseName,
            params.name,
            params.id,
            params.oriData && params.oriData.parent_path,
        );
        const sampleName: string = formatDepartmentName(
            true,
            props.enterpriseName,
            params.name,
            params.id,
            params.oriData && params.oriData.parent_path,
        );
        const isDisabledCheck = onDisablePermissionSwitch(params.oriData);
        const isAllowClick = params.checkable && !isDisabledCheck;
        const disabledCheck = !isAllowClick || (!isSelected && !!props.limit && selectedNum >= props.limit);
        const renderDepartmentMember = () => {
            const count = params.oriData ? params.oriData.member_count : 0;
            return props.isShowMember ? (
                <PreImg>
                    <Fragment>
                        <img className="content-file icon-member" src={departmentMemberIcon} alt="" />
                        <span className="member-count">{count}</span>
                    </Fragment>
                </PreImg>
            ) : null;
        };
        return (
            <li className="list-item" key={key}>
                <div className="content">
                    <div className="content-empty"></div>
                    <div className="content-check">
                        <Checkbox
                            isChecked={isSelected ? CHECKBOX_CHECK_TYPE.IS_CHECK : CHECKBOX_CHECK_TYPE.UN_CHECK}
                            onChange={(isChecked) => props.onSelectedChange(params, isChecked)}
                            disabledCheck={disabledCheck}
                        />
                    </div>
                    <PreImg>
                        <img className="content-file" src={params.id === '0' ? topIcon : fileIcon} alt="" />
                    </PreImg>
                    <If condition={props.isSearchMode}>
                        <div className="deepart-member">
                            <Tooltip
                                title={fullName}
                                placement="bottom"
                                getTooltipContainer={(node: HTMLElement) => listUlRef?.current || node}
                                hideArrow
                            >
                                <span className="name" onClick={() => !disabledCheck && props.onToggleName(params)}>
                                    {sampleName}
                                </span>
                            </Tooltip>
                            {renderDepartmentMember()}
                        </div>
                    </If>
                    <If condition={!props.isSearchMode}>
                        <div className="deepart-member">
                            <Tooltip
                                title={fullName}
                                placement="bottom"
                                hideArrow
                                getTooltipContainer={(node: HTMLElement) => listUlRef?.current || node}
                            >
                                <span
                                    className="name name-left"
                                    onClick={() => !disabledCheck && props.onToggleName(params)}
                                >
                                    {params.name}
                                </span>
                            </Tooltip>
                            {renderDepartmentMember()}
                        </div>
                    </If>

                    <div className="close">
                        <If condition={(!props.isSearchMode && params.isHaveNextLevel) || false}>
                            <PreImg>
                                <img src={rightIcon} alt="" onClick={() => props.onNextLevel(params)} />
                            </PreImg>
                        </If>
                    </div>
                </div>
            </li>
        );
    };

    const ListItemDepartmentRight = (params: IListItem, key: React.Key) => {
        const fullName: string = formatDepartmentName(
            false,
            props.enterpriseName,
            params.name,
            params.id,
            params.oriData && params.oriData.parent_path,
        );
        const sampleName: string = formatDepartmentName(
            true,
            props.enterpriseName,
            params.name,
            params.id,
            params.oriData && params.oriData.parent_path,
        );
        const isRootDepartment = `${params.id}` === '0';
        const isHideClose = onDisablePermissionSwitch(params.oriData) && !(props.checkableRoot && isRootDepartment);
        const hasFilter = !!props.onFilter;
        const memberCount = params.oriData?.member_count;
        const filteredCount = params.oriData?.filteredCount;
        const showCount = hasFilter && typeof memberCount === 'number';
        const displayCount = showCount
            ? ` (${typeof filteredCount === 'number' ? filteredCount : memberCount}/${memberCount})`
            : '';
        return (
            <li className="list-item" key={key}>
                <div className={`content${hasFilter ? ' content-filter' : ''}`}>
                    {!hasFilter && (
                        <PreImg>
                            <img className="content-file" src={params.id === '0' ? topIcon : fileIcon} alt="" />
                        </PreImg>
                    )}

                    <Tooltip
                        title={fullName + displayCount}
                        placement="bottom"
                        hideArrow
                        getTooltipContainer={(node: HTMLElement) => listUlRef?.current || node}
                    >
                        <span className="name">
                            {sampleName}
                            {displayCount}
                        </span>
                    </Tooltip>
                    <If condition={!isHideClose}>
                        {hasFilter ? (
                            <div className="list-item-actions">
                                <span
                                    className="action-btn action-filter"
                                    onClick={() => {
                                        FilterDialog({
                                            enterpriseName: props.enterpriseName,
                                            departmentItem: {
                                                ...params,
                                                oriData: {
                                                    ...params.oriData,
                                                    exclude_umu_ids: params.oriData?.exclude_umu_ids || [],
                                                },
                                            },
                                            onClickFilter: (updatedItem: IListItem) => {
                                                props.onFilter?.(updatedItem);
                                            },
                                        });
                                    }}
                                >
                                    {lang('筛选')}
                                </span>
                                <span className="action-btn action-remove" onClick={() => props.onClickRemove(params)}>
                                    {lang('移除')}
                                </span>
                            </div>
                        ) : (
                            <PreImg>
                                <img
                                    className="close"
                                    src={deleteIcon}
                                    alt=""
                                    onClick={() => props.onClickRemove(params)}
                                />
                            </PreImg>
                        )}
                    </If>
                </div>
            </li>
        );
    };

    const ListItemOwnerLeft = (params: IListItem, key: React.Key) => {
        const isSelected = params.isSelected;
        const userAvatar = (
            <div className="avatar">
                <UserAvatar src={params.avatar || ''} className="data-user-avatar" width={32} />
            </div>
        );

        return (
            <li className="list-item list-item-owner" key={key}>
                <div className="content">
                    <div className="content-check">
                        <Checkbox
                            isChecked={isSelected ? CHECKBOX_CHECK_TYPE.IS_CHECK : CHECKBOX_CHECK_TYPE.UN_CHECK}
                            onChange={(isChecked) => props.onSelectedChange(params, isChecked)}
                            disabledCheck={false}
                        />
                    </div>
                    {userAvatar}
                    <span className="name  name-left" onClick={() => params.checkable && props.onToggleName(params)}>
                        {params.name}
                    </span>
                </div>
            </li>
        );
    };

    const ListItemOwnerRight = (params: IListItem, key: React.Key) => {
        const userAvatar = (
            <div className="avatar">
                <UserAvatar src={params.avatar || ''} className="data-user-avatar" width={32} />
            </div>
        );

        return (
            <li className="list-item-owner list-item" key={key}>
                <div className="content">
                    {userAvatar}
                    <span className="name">{params.name}</span>
                    <PreImg>
                        <img className="close" src={deleteIcon} alt="" onClick={() => props.onClickRemove(params)} />
                    </PreImg>
                </div>
            </li>
        );
    };

    if (props.travelType === TravelType.department && props.sectionType === SectionType.left) {
        listChildren.push(ListItemDepartmentLeft(listItemData, props.index));
    } else if (props.travelType === TravelType.department && props.sectionType === SectionType.right) {
        listChildren.push(ListItemDepartmentRight(listItemData, props.index));
    } else if (props.travelType === TravelType.owner && props.sectionType === SectionType.left) {
        listChildren.push(ListItemOwnerLeft(listItemData, props.index));
    } else if (props.travelType === TravelType.owner && props.sectionType === SectionType.right) {
        listChildren.push(ListItemOwnerRight(listItemData, props.index));
    }

    return (
        <ul className="list-ul" ref={listUlRef}>
            {listChildren}
        </ul>
    );
};
